import styled, { css, keyframes } from 'styled-components';
import { Keyframes } from 'styled-components/dist/types';
import { FullscreenDiv } from '@ardoq/modal';
import { DrawerOrientation } from './types';

export const TRANSITION_TIME = 350;

const fullScreenCSS = css`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: flex-end;
`;

const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

const fadeOut = keyframes`
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
`;

export const DrawerBackdrop = styled.div<{
  $isVisible: boolean;
}>`
  ${fullScreenCSS};
  user-select: none;
  background-color: rgba(0, 0, 0, 0.2);

  /* ANIMATION */
  animation: ${({ $isVisible }) => ($isVisible ? fadeIn : fadeOut)}
    ${TRANSITION_TIME}ms ease;
  animation-fill-mode: both;
`;

export const DrawerFullscreenContainer = styled(FullscreenDiv)<{
  $hasBackdrop: boolean;
}>`
  pointer-events: ${({ $hasBackdrop }) => ($hasBackdrop ? 'auto' : 'none')};
`;

type DrawerContentContainerProps = {
  $isVisible: boolean;
  $orientation: DrawerOrientation;
};

const slideInY = keyframes`
  from {
    transform: translateY(100%);
  }
  to {
    transform: translateY(0);
  }
`;

const slideOutY = keyframes`
  from {
    transform: translateY(0);
  }
  to {
    transform: translateY(100%);
  }
`;

const slideInX = keyframes`
  from {
    transform: translateX(100%);
  }
  to {
    transform: translateX(0);
  }
`;

const slideOutX = keyframes`
  from {
    transform: translateX(0);
  }
  to {
    transform: translateX(100%);
  }
`;

const drawerContentAnimation = ({
  $isVisible,
  $orientation,
}: DrawerContentContainerProps): Keyframes => {
  if ($orientation === 'horizontal') {
    return $isVisible ? slideInY : slideOutY;
  }
  return $isVisible ? slideInX : slideOutX;
};

export const DrawerContentContainer = styled.div<DrawerContentContainerProps>`
  z-index: 1;
  pointer-events: auto;
  &:focus {
    outline: none;
  }

  /* ANIMATION */
  animation: ${drawerContentAnimation} ${TRANSITION_TIME}ms ease;
  /* holds the off-screen keyframe outside the animation's active duration, so the
     drawer doesn't flash visible before slide-in starts or after slide-out ends */
  animation-fill-mode: ${({ $isVisible }) =>
    $isVisible ? 'backwards' : 'forwards'};
`;

export const DrawerScroll = styled.div`
  overflow-y: auto;
  height: 100%;
`;
